import Vue from 'vue'
import get from 'lodash/get'

const NullComponent = {
  name: 'NullComponent',
  render (h) {
    return null
  },
}

Vue.component('NullComponent', NullComponent)

export default class Theme {
  constructor () {
    this.components = {}
    this.marketing = {}
  }

  getComponent (name) {
    const components = get(this, 'components', {})
    const getter = get(components, name)

    if (typeof getter === 'function') {
      return getter
    }

    return NullComponent
  }

  getMarketing (path) {
    if (!path) {
      return this.marketing
    }

    return get(this.marketing, path, NullComponent)
  }
}
